export const user = {
  accountDetails: "账号详情",
  activationPending: "等待激活",
  active: "已激活",
  administrator: "超级管理员",
  changeEmail: "更改邮箱",
  changeEmailError: "验证码不正确。",
  changeEmailTips: "验证码已发送到新的电子邮箱，请输入验证码进行验证。",
  deleteTip: "账号{0}将被删除。确定要继续吗？",
  driver: "司机",
  driverSameEmailAddress: "已存在用此电子邮箱注册的司机。",
  editAccount: "编辑账号",
  emailAlreadyExists: "此电子邮箱已存在。",
  emailHasBeenRegisteredIsPullInformation:
    "已导入同一个电子邮箱注册的用户的账号信息。|已导入同一个电子邮箱注册的司机的账号信息。",
  fleetManager: "车间管理员",
  newAccount: "新建账号",
  removeOnDate: "将于{0}删除",
  sendActivationNotice: "发送激活通知",
  sendActivationNoticeSuccessfully: "已发送激活邮件。",
  workXConnectCloudSettings: "VIA CWorkX Connect页面设置",
};
